import { Content, Item, ItemTitle, ItemContent } from './help-list.styled';

export const HelpList = ({ items }) => {
  const itemsEl = items.map((el, idx) => (
    <Item key={idx}>
      <ItemTitle>
        <img width="28" src={el.icon} alt="" />
        {el.title}
      </ItemTitle>
      <ItemContent>{el.info}</ItemContent>
    </Item>
  ));
  return <Content>{itemsEl}</Content>;
};
